// jmix-exit E3a.1: the access token lives in a module-private variable — never in localStorage or
// sessionStorage. A bundle-scoped variable is cleared on reload, which is exactly the in-memory
// lifetime an OAuth2 public client should have. Epic 3b wires the real /api/auth/* bridge that mints
// it (PKCE/cookie/CSRF); Epic 3a only needs the seam so the data layer compiles.
let accessToken: string | undefined;

export function getAccessToken(): string | undefined {
  return accessToken;
}

export function setAccessToken(token: string | undefined): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = undefined;
}
